import { defineMessages } from 'react-intl';

const messages = defineMessages({
  petFeeChargeWarning: {
    id: 'App.EditResidentHousehold.Pets.petFeeChargeWarning',
    defaultMessage:
      "Fees will post immediately as separate transactions and update the resident's balance.",
  },
  modalTitle: {
    id: 'App.EditResidentHousehold.Pets.modalTitle',

    defaultMessage: 'Household changes - Pet(s) Added',
  },
  confirm: {
    id: 'App.EditResidentHousehold.Pets.confirm',
    defaultMessage: 'Confirm',
  },
  cancel: {
    id: 'App.EditResidentHousehold.Pets.cancel',
    defaultMessage: 'Cancel',
  },
  noticedAddedPets: {
    id: 'App.EditResidentHousehold.Pets.noticedAddedPets',
    defaultMessage:
      'We noticed you added the following new pet(s) to this household:',
  },
  postPetFeesPrompt: {
    id: 'App.EditResidentHousehold.Pets.postPetFeesPrompt',
    // eslint-disable-next-line max-len
    defaultMessage:
      "Do you want to post pet fees to the ledger? If so, enter the quantity for each fee you'd like to post:",
  },
  petRentInfo: {
    id: 'App.EditResidentHousehold.Pets.petRentInfo',
    defaultMessage:
      // eslint-disable-next-line max-len
      'A pet rent charge will automatically begin the following month for the newly added pet(s). Service animals are exempt.',
  },
  petRentNotChargedInfo: {
    id: 'App.EditResidentHousehold.Pets.petRentNotChargedInfo',
    defaultMessage:
      // eslint-disable-next-line max-len
      'Pet Rent on this lease is $0.00, so no pet rent charge will be created for the newly added pet(s). Add the charge manually if this household should be charged.',
  },
});

export default messages;
